import { StanCard } from '@/components';
import { ReactNode } from 'react';

export function PaymentDetailsCard({
    titleArea,
    buttonArea,
    contentArea,
    className,
}: {
    titleArea: ReactNode;
    buttonArea?: ReactNode;
    contentArea: ReactNode;
    className?: string;
}) {
    return (
        <StanCard className={`w-full ${className}`}>
            <div className='flex w-full flex-col gap-8'>
                <div className='flex items-center'>
                    <div className='flex items-center text-xl font-bold'>{titleArea}</div>
                    {buttonArea && <div className='ml-auto hidden items-center gap-1 md:flex'>{buttonArea}</div>}
                </div>

                <div className='content'>{contentArea}</div>
                {buttonArea && (
                    <div className='flex flex-col items-center gap-2 md:hidden md:flex-row'>{buttonArea}</div>
                )}
            </div>
        </StanCard>
    );
}
